<template>
  <div>
    <div class="ui form">
      <div class="fields">
        <div class="eight wide field">
          <label>{{ $t("components.licenseForm.Descripcion") }}</label>
          <div class="ui input">
            <input type="text" v-model="currentLicense.description">
          </div>
        </div>
        <div class="eight wide field">
          <label>{{ $t("components.licenseForm.Codigo_licencia") }}</label>
          <div class="ui action input">
            <input :placeholder="$t('components.licenseForm.Codigo_licencia_ejemplo')" type="text" style="text-align:center" v-model="currentLicense.licenseCode" :disabled="!esRegistroNuevo">
            <button class="ui icon button" @click="generateLicenseCode()" data-inverted="" :data-tooltip="$t('components.licenseForm.Generar_codigo_licencia')" data-position="bottom right" :disabled="!esRegistroNuevo"><i class="sync icon"></i></button>
          </div>
        </div>
      </div>
      <div class="fields">
        <div class="eight wide field">
          <label>{{ $t("components.licenseForm.Tipo_software") }}</label>
          <div class="ui action input">
            <select class="ui dropdown fluid" v-model="currentLicense.softwareType" :disabled="!esRegistroNuevo">
              <option value="0">{{ $t("components.licenseForm.Seleccione_un_tipo_software") }}</option>
              <option value="dattalab">{{ $t("components.licenseForm.Tipo_software_dattalab") }}</option>
              <option value="smartagriculture">{{ $t("components.licenseForm.Tipo_software_smartagriculture") }}</option>
              <option value="irrideasmart">{{ $t("components.licenseForm.Tipo_software_irrideasmart") }}</option>
            </select>
          </div>
        </div>
        <div class="four wide field">
          <label>{{ $t("components.licenseForm.Version_software") }}</label>
          <div class="ui action input">
            <input :placeholder="$t('components.licenseForm.Version_software_ejemplo')" type="text" style="text-align:center" v-model="currentLicense.softwareVersion" :disabled="!esRegistroNuevo">
          </div>
        </div>
        <div class="four wide field">
          <label>{{ $t("components.licenseForm.Version_firmware") }}</label>
          <div class="ui action input">
            <input :placeholder="$t('components.licenseForm.Version_firmware_ejemplo')" type="text" style="text-align:center" v-model="currentLicense.firmwareVersion" :disabled="!esRegistroNuevo">
          </div>
        </div>
      </div>
    </div>
    <h2 class="ui dividing header"></h2>
    <button class="ui olive labeled icon button" style="float:right" @click="save()">
      <i class="icon add"></i>{{ $t('components.common.Guardar') }}
    </button>
    <router-link class="item" to="/home">
      <button class="ui labeled icon button" style="float:right">
        <i class="remove icon"></i> {{ $t('components.common.Volver') }}
      </button>
    </router-link>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
const crypto = require('crypto');
import Vue from 'vue';

// constantes para generar c&oacute;digos de licencia aleatorios
const CARACTERES_LETRAS = [ "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "X", "Y", "Z" ];
const CARACTERES_NUMEROS = [ "0", "1", "2", "3", "4", "5", "6", "7", "8", "9" ];

export default {
  name: 'LicenseForm',
  data: function () {
    return {
      esRegistroNuevo: (this.$route.params.idlicense == null),
      currentLicense: { description: '', licenseCode: '', softwareType: '0', softwareVersion: '', firmwareVersion: '' },
    };
  },
  methods: {
    refresh: function () {
      if (this.$route.params.idlicense == null) {
        return;
      }

      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get('/license/' + this.$route.params.idlicense).then(response => {
        if (response) {
          if (response.data != null) {
            this.currentLicense = response.data;
          }
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.licenseForm.Hay_un_error_obtener_datos_licencia'),
          text: e
        });
      });
    },
    getRandomBoolean() {
      const buffer = crypto.randomBytes(4);
      return (parseInt(buffer.toString('hex'), 16) % 2) !== 0;
    },
    getRandomInt() {
      const buffer = crypto.randomBytes(4);
      return parseInt(buffer.toString('hex'), 16);
    },
    generateLicenseCode: function () {
      let licenseCode = "";

    	try {
        for(let i = 0; i < 5; i++) {
					for(let j = 0; j < 5; j++) {
            for(let k = 0; k < 124; k++) this.getRandomBoolean();

              const isCaracterLetra = this.getRandomBoolean();
              let randomInt = 0;

              if (isCaracterLetra) {
                for(let k = 0; k < 269; k++) this.getRandomInt();
                randomInt = this.getRandomInt();

                if (randomInt < 0) {
                  randomInt *= -1;
                }

                let indexCaracterLetra =  this.getRandomInt() % 25;
                licenseCode += CARACTERES_LETRAS[indexCaracterLetra];
              }
              else {
                for(let k = 0; k < 174; k++) this.getRandomInt();
                randomInt = this.getRandomInt();

                if (randomInt < 0) {
                  randomInt *= -1;
                }

                let indexCaracterNumero = randomInt % 10;
                licenseCode += CARACTERES_NUMEROS[indexCaracterNumero];
              }
					}

					if (i == 4) {
            break;
          }

					licenseCode += "-";
				}
			} catch (e) {
			}

      this.currentLicense = Object.assign(this.currentLicense, { licenseCode });
    },
    save: function () {
      if (this.currentLicense.description.length === 0) {
        this.$swal.fire({ type: 'error', title: this.$i18n.t('components.licenseForm.Introducir_descripcion') });
        return;
      }

      if (this.esRegistroNuevo) {
        if (this.currentLicense.licenseCode.length === 0) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.licenseForm.Introducir_codigo_licencia') });
          return;
        }

        if (!(/^(([0-9A-Z]{5})\-){4}([0-9A-Z]{5})$/.test(this.currentLicense.licenseCode))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.licenseForm.Introducir_codigo_licencia'), text: this.$i18n.t('components.licenseForm.Introducir_codigo_licencia_detalle') });
          return;
        }

        if (this.currentLicense.softwareType === '0') {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.licenseForm.Introducir_tipo_software') });
          return;
        }

        if (this.currentLicense.softwareVersion.length === 0) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.licenseForm.Introducir_version_software') });
          return;
        }

        if (!(/^([0-9]{1,2})\.([0-9]{2})$/.test(this.currentLicense.softwareVersion))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.licenseForm.Introducir_version_software'), text: this.$i18n.t('components.licenseForm.Introducir_version_software_detalle') });
          return;
        }

        if (this.currentLicense.firmwareVersion.length === 0) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.licenseForm.Introducir_version_firmware') });
          return;
        }

        if (!(/^([0-9]{1,2})\.([0-9]{2})$/.test(this.currentLicense.firmwareVersion))) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.licenseForm.Introducir_version_firmware'), text: this.$i18n.t('components.licenseForm.Introducir_version_firmware_detalle') });
          return;
        }
      }

      if (this.esRegistroNuevo) {
        axios.post('/license', this.currentLicense).then(response => {
          this.$swal.fire(
            this.$i18n.t('components.licenseForm.Save_Ok_Title'),
            this.$i18n.t('components.licenseForm.Save_Ok_Text'),
            'success'
          );

          this.$router.push({ name: 'home' });
        }).catch(e => {
          if (e.response.status === 400 || e.response.status === 409) {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.licenseForm.Hay_un_error_actualizar_datos_licencia'),
              text: this.$i18n.t('components.licenseForm.Hay_un_error_actualizar_datos_licencia_' + e.response.status)
            });
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.licenseForm.Hay_un_error_actualizar_datos_licencia'),
              text: e
            });
          }
        });
      } else {
        axios.put('/license/' + this.currentLicense._id, this.currentLicense).then(response => {
          this.$swal.fire(
            this.$i18n.t('components.licenseForm.Save_Ok_Title'),
            this.$i18n.t('components.licenseForm.Save_Ok_Text'),
            'success'
          );

          this.$router.push({ name: 'home' });
        }).catch(e => {
          if (e.response.status === 400 || e.response.status === 404) {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.licenseForm.Hay_un_error_actualizar_datos_licencia'),
              text: this.$i18n.t('components.licenseForm.Hay_un_error_actualizar_datos_licencia_' + e.response.status)
            });
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.licenseForm.Hay_un_error_actualizar_datos_licencia'),
              text: e
            });
          }
        });
      }
    }
  },
  mounted: function () {
    this.refresh();

    setTimeout(() => {
      $('.ui.dropdown').dropdown();
    }, 500);
  }
};
</script>
